module.exports = __webpack_public_path__ + "mo/img/swiper_bg08.9200c567.png";